import { GET_ORDER_REPORT_LIST, GET_ORDER_REPORT_LIST_SUCCESS } from '../storeTypes';

export const ActionGetOrderReportList = (payload, callback) => ({
  type: GET_ORDER_REPORT_LIST,
  payload,
  callback,
});

export const ActionGetOrderReportListSuccess = payload => ({
  type: GET_ORDER_REPORT_LIST_SUCCESS,
  payload,
});
